module.exports = __webpack_public_path__ + "static/img/detail_ddr_02.b1d0db0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/ddr-banner-campaign/detail_ddr_02.jpg
// module id = 233
// module chunks = 2